module.exports = __webpack_public_path__ + "assets/img/app_use_mobile.179294e2.png";